import { getCurrentRoute } from './getCurrentRoute';
import type { RegisterRouteFunction, RouterOptions } from 'owa-router';

export const mailRouterOptions: RouterOptions = {
    routeGenerator: Promise.resolve(getCurrentRoute),
    vdir: 'mail',
    registerRoutes: initializeMailRoutes,
    defaultRoute: '/',
};

function defaultModuleRouterHandler() {}

const DEFAULT_ROUTE = '/';

async function initializeMailRoutes(registerRoute: RegisterRouteFunction) {
    // register the base routes to make sure back button navigation works for module switch
    registerRoute(DEFAULT_ROUTE, defaultModuleRouterHandler);
    registerRoute('/:folderId', defaultModuleRouterHandler);
}
